import React from 'react';
import { Chip } from '@mui/material';

export interface StatusBadgeProps {
  status?: string | null;
}

const statusStyles = (status: string) => {
  const value = status.toUpperCase();
  if (value === 'CLOSED') return { bgcolor: '#e7f6ec', color: '#215732', borderColor: '#b8ddc4', variant: 'filled' as const };
  if (value === 'SUPPRESSED') return { bgcolor: '#fff', color: '#667085', borderColor: '#cbd5e1', variant: 'outlined' as const };
  if (value === 'ACKED') return { bgcolor: '#eef4ff', color: '#1d4f91', borderColor: '#c9d9f2', variant: 'filled' as const };
  if (value === 'IN_REVIEW') return { bgcolor: '#fff4db', color: '#8a5a00', borderColor: '#f1d08a', variant: 'filled' as const };
  return { bgcolor: '#e6f2fb', color: '#0d5c91', borderColor: '#c5dced', variant: 'filled' as const };
};

const statusLabel = (status: string | null | undefined): string => {
  const value = String(status || 'OPEN').toUpperCase();
  if (value === 'OPEN') return 'Needs review';
  if (value === 'ACKED') return 'Assigned';
  if (value === 'IN_REVIEW') return 'In review';
  if (value === 'CLOSED') return 'Resolved';
  if (value === 'SUPPRESSED') return 'Suppressed';
  return value;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const value = String(status || 'OPEN').toUpperCase();
  const styles = statusStyles(value);
  return (
    <Chip
      size="small"
      label={statusLabel(status)}
      variant={styles.variant}
      sx={{
        height: 27,
        borderRadius: 999,
        bgcolor: styles.variant === 'filled' ? styles.bgcolor : undefined,
        color: styles.color,
        border: '1px solid',
        borderColor: styles.borderColor,
        fontWeight: 800,
        '& .MuiChip-label': { px: 1, lineHeight: 1.1 },
      }}
    />
  );
};

export default StatusBadge;
